import cx from 'classnames';
import { useTranslation } from 'next-i18next';
import { Text } from '@dx-ui/global-ui-prism';

export const CarouselNoImage = ({
  className,
  isFullSize = false,
}: {
  className?: string;
  isFullSize?: boolean;
}) => {
  const { t } = useTranslation('osc-carousel');

  return (
    <div
      className={cx(
        'flex items-center justify-center bg-surface-legacy @container/no-image',
        { 'h-full w-full': isFullSize, 'aspect-[3/2]': !isFullSize },
        className
      )}
    >
      <Text as="span" color="muted">
        {t('noPhotoAvailable')}
      </Text>
    </div>
  );
};
